import React from 'react';
import ServiceTemplate from './ServiceTemplate';

export default function PlanesNegocio() {
  return <ServiceTemplate serviceName="planes-de-negocio" />;
}
